import React, { useState, useEffect, useContext } from "react";
import { useRouter } from "next/router";
import { push } from "firebase/database";
import { UserContext } from "../../contexts/UserContext";
import { GlobalPageDataContext } from "../../contexts/GlobalPageDataContext";
import { getRef, refs } from "../../data/firebase/firebaseRefKit";
import pageKind from "../../data/enums/pageKind";

export default function useViewStatistics(
  options = { reportEvery: 15 * 60 * 1000 }
  // options = { reportEvery: 10 * 1000 }
) {
  const { me } = useContext(UserContext);
  const { globalPageData } = useContext(GlobalPageDataContext);
  const router = useRouter();
  const { page, event } = router.query;

  function getPageFromSlug(slug) {
    if (!slug) {
      const mainPage =
        Object.values(globalPageData).filter(
          (page) => page.kind === pageKind.MAIN_PAGE
        )?.[0] ?? null;
      return mainPage;
    }

    const page =
      Object.values(globalPageData).filter(
        (page) =>
          (page.kind === pageKind.VIDEO_PAGE ||
            page.kind === pageKind.MEETING_PAGE) &&
          page.slug === slug
      )?.[0] ?? null;

    return page;
  }

  function writeTimestampToFirebase() {
    const pageData = getPageFromSlug(page);
    if (!pageData) return;

    const pageSlug = pageData.slug;
    const eventUserId = me?.id;
    const ref = getRef(refs.statistics.$eventSlug.$pageSlug.$eventUserId, {
      pageSlug,
      eventSlug: event,
      eventUserId,
    });
    if (ref) push(ref, Date.now());
  }

  useEffect(() => {
    if (me && globalPageData && event) {
      writeTimestampToFirebase();
      const reportInterval = setInterval(
        writeTimestampToFirebase,
        options.reportEvery
      );

      return () => {
        if (reportInterval) clearInterval(reportInterval);
      };
    }
  }, [me, page, event, globalPageData]);
}
